
const  HeaderSection = ({title}) =>
{
    return (
        <div className="section-header">
                <h1>{title}</h1>
            </div>
    )
}

export default HeaderSection;